import Cookies from 'universal-cookie';
import { QAP_COOKIE } from '../constants';
import env from '../env';

const cookies = new Cookies();

export function getAuthCookieName(): string {
  return `${QAP_COOKIE}_${env.ENVIRONMENT}`;
}

/** Options must match for both set and remove, or the browser leaves the cookie in place. */
export function getAuthCookieOptions() {
  const isLocalhost = window.location.hostname === 'localhost';
  return {
    path: '/',
    domain: env.DOMAIN,
    sameSite: (isLocalhost ? 'lax' : 'none') as 'lax' | 'none',
    secure: !isLocalhost,
    httpOnly: false,
  };
}

export function setAuthCookie(token: string, cookiesInstance: Cookies = cookies): void {
  cookiesInstance.set(getAuthCookieName(), token, getAuthCookieOptions());
}

export function removeAuthCookie(cookiesInstance: Cookies = cookies): void {
  const name = getAuthCookieName();
  const options = getAuthCookieOptions();
  // Remove with the same options used when setting
  cookiesInstance.remove(name, options);
  // Also clear any legacy cookie that may have been set without domain
  cookiesInstance.remove(name, { path: '/' });
  cookiesInstance.remove(name);
}
